import { useState, useEffect } from 'react';
import { ParsedLocationScheduledOverride } from '@edwt/cms/prisma/getAllLocations';

function parseTimeString(timeString: string) {
    const [hours, minutes] = timeString.split(":").map(Number);

    if (isNaN(hours) || isNaN(minutes)) return new Date();

    return new Date(1970, 0, 1, hours, minutes);
}

export function getLocationOverrides(overrideSchedule: ParsedLocationScheduledOverride[], currentDate: Date) {
    // search the overrideSchedule array for the first status that is on todays date (date) and falls within the current time (within it's startTime and endTime fields)
    const currentStatus = overrideSchedule.find(status => {

        const statusDate = new Date(status.date);

        const statusStartTime = parseTimeString(status.startTime);
        statusStartTime.setDate(statusDate.getDate());
        statusStartTime.setFullYear(statusDate.getFullYear());
        statusStartTime.setMonth(statusDate.getMonth());

        const statusEndTime = parseTimeString(status.endTime);
        statusEndTime.setDate(statusDate.getDate());
        statusEndTime.setFullYear(statusDate.getFullYear());
        statusEndTime.setMonth(statusDate.getMonth());

        return currentDate.getDate() === statusDate.getDate() && currentDate.getTime() >= statusStartTime.getTime() && currentDate.getTime() <= statusEndTime.getTime();
    });

    return {
        overrideWaitTime: currentStatus?.waitTime ? currentStatus.waitTime : false as false,
        overrideAlertTitle: currentStatus?.alertTitle ? currentStatus.alertTitle : false as false,
        overrideAlertDescription: currentStatus?.alertDescription ? currentStatus.alertDescription : false as false,
        overrideAdditionalInfo: currentStatus?.additionalInfo ? currentStatus.additionalInfo : false as false,
        overrideOpenStatus: currentStatus?.openStatus ? currentStatus.openStatus : false as false,
    };

}

export function useLocationOverrides(overrideSchedule: ParsedLocationScheduledOverride[]) {

    const [currentDate, setCurrentDate] = useState<Date>(new Date());

    const [activeStatus, setActiveStatus] = useState<{
        overrideWaitTime: ParsedLocationScheduledOverride['waitTime'] | false;
        overrideAlertTitle: ParsedLocationScheduledOverride['alertTitle'] | false;
        overrideAlertDescription: ParsedLocationScheduledOverride['alertDescription'] | false;
        overrideAdditionalInfo: ParsedLocationScheduledOverride['additionalInfo'] | false;
        overrideOpenStatus: ParsedLocationScheduledOverride['openStatus'] | false;
    }>(getLocationOverrides(overrideSchedule, currentDate));


    useEffect(() => {

        const interval = setInterval(() => {
            setCurrentDate(new Date());

            setActiveStatus(getLocationOverrides(overrideSchedule, currentDate));

        }, 10 * 1000);

        return () => clearInterval(interval);
    }, [currentDate, overrideSchedule]);

    return activeStatus;
}